

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Typography, Descriptions, message } from 'antd';
import axios from 'axios';

const { Title } = Typography;

const JobSheet: React.FC = () => {
  const { id } = useParams();
  const [sheet, setSheet] = useState<any>(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/manufacturing/job-sheets/${id}`)
      .then((res) => setSheet(res.data))
      .catch(() => message.error('Failed to load job sheet'));
  }, [id]);

  if (!sheet) return null;

  return (
    <Card>
      <Title level={4}>Job Sheet: {sheet.work_order_no}</Title>
      <Descriptions bordered column={1} size="small">
        <Descriptions.Item label="Product Name">{sheet.product_name}</Descriptions.Item>
        <Descriptions.Item label="Quantity">{sheet.quantity}</Descriptions.Item>
        <Descriptions.Item label="Technician">{sheet.technician}</Descriptions.Item>
        <Descriptions.Item label="Timeline">
          {sheet.timeline?.[0] || 'N/A'} → {sheet.timeline?.[1] || 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Stage">{sheet.stage}</Descriptions.Item>
        <Descriptions.Item label="Created At">{new Date(sheet.created_at).toLocaleString()}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default JobSheet;